import React, { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import { Typography, Breadcrumb, Spin, Alert } from 'antd'
import { HomeOutlined, UserOutlined, EditOutlined } from '@ant-design/icons'
import UserForm from '../components/users/UserForm'
import userService from '../services/userService'
import { User } from '../types/users'

const UserEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const [user, setUser] = useState<User | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchUser = async () => {
      setLoading(true)
      setError(null)
      try {
        if (!id) {
          throw new Error('User ID is required')
        }
        const data = await userService.getUserById(id)
        setUser(data)
      } catch (error) {
        console.error('Error fetching user:', error)
        setError('Không thể tải thông tin người dùng. Vui lòng thử lại sau.')
      } finally {
        setLoading(false)
      }
    }

    fetchUser()
  }, [id])

  if (loading) {
    return (
      <div className='flex items-center justify-center h-64 p-6'>
        <Spin size='large' tip='Đang tải...' />
      </div>
    )
  }

  if (error || !user) {
    return (
      <div className='p-6'>
        <Alert
          message='Lỗi'
          description={error || 'Không tìm thấy người dùng'}
          type='error'
          showIcon
        />
      </div>
    )
  }

  return (
    <div className='p-6'>
      <div className='mb-6'>
        <Breadcrumb
          items={[
            {
              title: (
                <Link to='/admin/dashboard'>
                  <HomeOutlined /> Trang chủ
                </Link>
              )
            },
            {
              title: (
                <Link to='/admin/users'>
                  <UserOutlined /> Người dùng
                </Link>
              )
            },
            {
              title: (
                <span>
                  <EditOutlined /> Chỉnh sửa
                </span>
              )
            }
          ]}
        />
      </div>

      <UserForm initialData={user} isEdit={true} />
    </div>
  )
}

export default UserEdit
